import React from 'react';
import {
  Asset_requirements,
  Empty_state_image_str,
  empty_state_title,
  Enable_promotion_switch,
  promotion_cards_str,
  promotion_configure_section,
  promotion_file_details,
  promotion_file_type,
  Promotion_str,
  send_promotion_section,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import SwitcherPanel from '../components/PanelsComponents/Buttons/SwitcherPanel';
import { arrangeScreenInJson } from '../screens/ScreensOrdering';
import BreakLine from '../components/PanelsComponents/General/BreakLine';
import Title from '../components/PanelsComponents/Text/Title';
import RegularText from '../components/PanelsComponents/Text/RegularText';
import Paragraph from '../components/PanelsComponents/Text/Paragraph';
import Details from '../components/PanelsComponents/Text/Details';
import UploadMenu from '../components/PanelsComponents/Upload/UploadMenu';

//= ========================================================================

const Panel_Y02_keyboardPromotion = ({
  onStepPressed,
  onConfigChanged,
  globJSON,
  selectedScreen,
  language,
}) => {
  const { promotion } = globJSON.configurations.keyboard;
  const onValueChanged = (key, value) => {
    promotion[key] = value;
    arrangeScreenInJson(globJSON, onConfigChanged);
  };
  const listObject = [
    {
      subHeadline: empty_state_title,
      fileId: 'configurations/launch/empty_state/empty_state_icon',
    },
  ];
  return (
    <FullPagePanel
      globJSON={globJSON}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      panelHeadline={Promotion_str}
      paragraph={promotion_configure_section}
      tooltipsTitles={globJSON.configurations.keyboard.screens_ordering}
      disableEditElements
      language={language}
      paddingVertical={25}
    >
      <SwitcherPanel
        text={Enable_promotion_switch}
        value={promotion.enable_promotion}
        onValueChanged={(value) => {
          onValueChanged('enable_promotion', value);
        }}
      />
      <BreakLine />
      <Title isBold>{Asset_requirements}</Title>
      <RegularText>{promotion_cards_str}</RegularText>
      <Paragraph>{send_promotion_section}</Paragraph>
      <Details marginBottom={12}>{promotion_file_details}</Details>
      <UploadMenu
        globJSON={globJSON}
        onConfigChanged={onConfigChanged}
        headline={Empty_state_image_str}
        details={promotion_file_type}
        listObject={listObject}
      />
      <BreakLine />
    </FullPagePanel>
  );
};
export default Panel_Y02_keyboardPromotion;
